/**
 * Ordre d'affichage des référentiels de paramètres (« Gestion des paramètres » → colonne Ordre).
 *
 * 0027758 : l'ordre pilote l'affichage des conditionnements (grille d'orientation, options du
 * centre, colonnes des compteurs). Le repli historique `order ?? 0` faisait remonter EN TETE
 * tout paramètre dont l'ordre n'est pas renseigné — sur STE, Blister n'en a pas et ouvrait donc
 * la grille devant Selfix, exactement l'inverse de l'ordre attendu.
 *
 * Règle retenue : un ordre renseigné impose le rang ; un ordre absent passe APRES tous ceux qui
 * en ont un. Le code3 départage les ex æquo pour que le rang reste stable d'un chargement à
 * l'autre (l'ordre d'arrivée de l'API n'est pas garanti).
 */

/** Forme minimale attendue : tout paramètre, hydraté ou non. */
export interface IOrderableParameter {
    order?: number | null;
    code3?: string | null;
}

/** Rang de tri : l'absence d'ordre renvoie l'infini, donc la fin de liste. */
const rank = (parameter?: IOrderableParameter | null): number =>
    parameter?.order == null ? Number.POSITIVE_INFINITY : parameter.order;

/** Comparateur `Array.prototype.sort` : ordre croissant, non renseignés en dernier. */
export const compareByParameterOrder = (
    a?: IOrderableParameter | null,
    b?: IOrderableParameter | null
): number => {
    const rangA = rank(a);
    const rangB = rank(b);
    if (rangA !== rangB) return rangA - rangB;
    return (a?.code3 ?? '').localeCompare(b?.code3 ?? '');
};
